




















































import { Component, Vue, Ref } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CustomersTable from "@/components/CustomersTable.vue";
import GlobalFilterSensitiveMixin from '@/mixins/GlobalFilterSensitiveMixin';

@Component({
  components: {
    CustomersTable
  },
  mixins: [
    GlobalFilterSensitiveMixin
  ]
})
export default class Customers extends Vue {

  @Ref("all") all?: CustomersTable;
  @Ref("reservationHolder") reservationHolder?: CustomersTable;
  @Ref("guest") guest?: CustomersTable;
  @Ref("owner") owner?: CustomersTable;

  @Getter("appParams/typeId") tenantTypeId?: number;

  get tab() {
    const tab = this.$route.query.tab;
    return tab && !isNaN(+tab) ? +tab - 1 : 0;
  }

  set tab(fresh: number) {
    this.$router.replace({
      path: this.$route.path,
      params: this.$route.params,
      query: { tab: (fresh + 1).toString() },
      replace: true,
    });
  }

  refreshAll() {
    this.all?.refresh();
    this.reservationHolder?.refresh();
    this.guest?.refresh();
    this.owner?.refresh();
  }
}
